import { isAfter } from 'date-fns';

/**
 * Transforms a accommodation booking part fulfillments into a refundable for accommodations.
 */
export function transformRefundableAccommodation(
    accommodation: ApiSchema['Accommodation'],
    apiBooking: ApiSchema['Booking'],
): RefundableAccommodation {
    const fulfillment = apiBooking.fulfillments?.find(f => f.issuer !== 'TOFT' && f.bookingParts?.some(bp => bp.id === accommodation.id));
    const dateFrom = zurichDate(accommodation.validFrom);
    const dateUntil = zurichDate(accommodation.validUntil);
    const id = accommodation.id;
    const fulfillmentId = fulfillment?.id;
    const type = 'Accommodation';
    const summaryLine1 = accommodation.accommodationDetails?.name ?? '';
    const summaryLine2 = `${formatDateFromTo(dateFrom, dateUntil)} (${formatFromToDuration(dateFrom, dateUntil, true)})`;
    const detailLine1 = accommodation.summary ?? '';
    const detailLine2 = undefined;
    const status = accommodation.status;
    const price = accommodation.price;
    const refundConditionDate = accommodation.afterSaleConditions?.find(c => c.condition === 'REFUND')?.validUntil;
    const refundDeadline = refundConditionDate ? zurichDate(refundConditionDate) : undefined;
    const isExpired = refundDeadline ? isAfter(zurichDate(), refundDeadline) : false;
    const isRefunded = accommodation.status === 'REFUNDED';
    const isRefundable = !!refundDeadline && accommodation.status === 'FULFILLED' && !isExpired;

    return {
        id,
        fulfillmentId,
        type,
        summaryLine1,
        summaryLine2,
        detailLine1,
        detailLine2,
        status,
        price,
        refundDeadline,
        isExpired,
        isRefunded,
        isRefundable,
    };
}
